import { useSelector } from 'react-redux';
import { selectLoggedIn } from 'session-selectors';

export default () => useSelector(selectLoggedIn);

// TODO: Not sure about this hook being here.
// Better placed with duck/selectors in redux/session folder?
